/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconBottledBolt: {
  name: 'bottled_bolt';
  data: string;
} = {
  name: 'bottled_bolt',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M459.675 113.088H165.859c0 69.444-40.672 25.62-40.672 102.043V515.66a58.669 58.669 0 0 0 58.882 58.883h255.159a58.669 58.669 0 0 0 58.882-58.883V215.131c.001-80.939-38.435-35.048-38.435-102.043zM224.81 542.116l-.002.005h-.003l.005-.005 70.762-190.385H167.208l207.357-220.083-55.954 160.695h139.885L224.81 542.116z"/><path d="M118.979 27.903v89.858h46.807c.044-1.504.073-3.048.073-4.673h293.816c0 1.63.029 3.173.074 4.673h47.519V27.903H118.979z"/></svg>`,
};
